import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { TextField } from "@mui/material";

// Function to dynamically generate month options for past and future years
const generateMonthOptions = (pastYears, futureYears) => {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const options = [];
    const currentYear = new Date().getFullYear();

    for (let year = currentYear - pastYears; year <= currentYear + futureYears; year++) {
        months.forEach((month, index) => {
            const monthValue = `${year}-${String(index + 1).padStart(2, "0")}`;
            const monthLabel = `${month} ${year}`;
            options.push({ value: monthValue, label: monthLabel });
        });
    }

    return options;
};

const theme = createTheme({
    palette: {
        primary: {
            main: "#7451f8",
        },
        secondary: {
            main: "#6c757d",
        },
    },
});

const TimeTableMasterNew = ({ title = "Add New Timetable Master" }) => {
    const currentDate = new Date();
    const defaultMonth = currentDate.toISOString().slice(0, 7); // e.g., "2025-08"
    const defaultYear = currentDate.getFullYear();
    const navigate = useNavigate();
    const [inputValues, setInputValues] = useState({
        center_id: localStorage.getItem("center_id"),
        class_id: "",
        month: defaultMonth,
        effective_from: "",
        effective_to: "",
    });
    const [classOptions, setClassOptions] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpcoming, setIsUpcoming] = useState(false);
    const token = localStorage.getItem("token");

    const monthOptions = generateMonthOptions(2, 3);
    // Set default month and year to current date (August 2025)
    
    const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
    const [selectedYear, setSelectedYear] = useState(defaultYear.toString());
    // const yearOptions = generateYearOptions(2, 3); // 2023–2028

    const redirectToLogin = () => {
        alert("Please login first, then you can access this page...");
        window.location.href = "/";
    };

    useEffect(() => {
        fetchClassNames();
    }, []);

    // Add new handlers
    const handleMonthChange = (event) => {
        const monthValue = event.target.value;
        console.log("monthValue", monthValue)
        setSelectedMonth(monthValue);
        setInputValues((prev) => ({
            ...prev,
            month: monthValue,
        }));
    };

    const handleYearChange = (event) => {
        const yearValue = event.target.value;
        setSelectedYear(yearValue);
        const newMonthValue = `${yearValue}-${selectedMonth.slice(5, 7)}`; // Keep the month part
        setSelectedMonth(newMonthValue);
        setInputValues((prev) => ({
            ...prev,
            month: newMonthValue,
        }));
    };

    const fetchClassNames = async () => {
        try {
            const center_id = localStorage.getItem("center_id");
            const response = await fetch(`${serverUrl}/class_ids/${center_id}`);
            if (!response.ok) throw new Error("Failed to fetch classes");
            const data = await response.json();
            const nameList = data.data.map(({ id, name }) => ({
                value: id,
                label: name,
            }));
            setClassOptions(nameList);
        } catch (error) {
            console.error("Error fetching classes:", error);
            toast.error("Failed to fetch class data");
        }
    };

    const handleClassSelectChange = (selectedOption) => {
        setInputValues({
            ...inputValues,
            class_id: selectedOption.value,
        });
        setSelectedClass(selectedOption);
    };

    const handleMonthSelectChange = (selectedOption) => {
        setInputValues({
            ...inputValues,
            month: selectedOption.value,
        });
    };

    const handleInputChange = (e) => {
        setInputValues({
            ...inputValues,
            [e.target.name]: e.target.value,
        });
    };

    const handleUpcomingChange = (event) => {
        const checked = event.target.checked;
        setIsUpcoming(checked);
        if (checked) {
            setInputValues({
                ...inputValues,
                effective_from: "",
                effective_to: "",
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        console.log("inputValues.month", inputValues.month)
        if (!inputValues.center_id || !inputValues.class_id || !inputValues.month) {
            toast.error("Please fill all required fields");
            setIsLoading(false);
            return;
        }

        if (!isUpcoming && !inputValues.effective_from) {
            toast.error("Effective From is required for non-upcoming timetables");
            setIsLoading(false);
            return;
        }

        try {
            const response = await fetch(`${serverUrl}/add_timetable_master`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    center_id: inputValues.center_id,
                    class_id: inputValues.class_id,
                    month: inputValues.month,
                    effective_from: isUpcoming ? null : inputValues.effective_from,
                    effective_to: isUpcoming ? null : inputValues.effective_to,
                }),
            });

            const data = await response.json();
            if (data.code === "201") {
                toast.success("Timetable master created successfully!");
                setInputValues({
                    center_id: localStorage.getItem("center_id"),
                    class_id: "",
                    month: "",
                    effective_from: "",
                    effective_to: "",
                });
                setSelectedClass(null);
                setIsUpcoming(false);
                setTimeout(() => {
                    navigate("/time-table");
                }, 1000);
            } else {
                toast.error(data.message || "Failed to create timetable master");
            }
        } catch (error) {
            console.error("Error creating timetable master:", error);
            toast.error("An error occurred while creating the timetable master");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ThemeProvider theme={theme}>
            {!token && redirectToLogin()}
            {token && (
                <div className="new">
                    <Sidebar />
                    <div className="newContainer">
                        <Navbar />
                        <div className="contentWrapper">
                            <Card className="formCard">
                                <CardContent className="cardContent">
                                    <Typography
                                        variant="h5"
                                        component="h2"
                                        gutterBottom
                                        className="formTitle"
                                    >
                                        {title}
                                    </Typography>
                                    <form onSubmit={handleSubmit} className="responsiveForm">
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6} className="formGridItem">
                                                <div className="formInput">
                                                    <label>Class *</label>
                                                    <Select
                                                        options={classOptions}
                                                        value={selectedClass}
                                                        onChange={handleClassSelectChange}
                                                        required
                                                        className="selectInput"
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: "46px",
                                                                borderColor: "#e2e8f0",
                                                                "&:hover": {
                                                                    borderColor: "#cbd5e0",
                                                                },
                                                            }),
                                                            valueContainer: (base) => ({
                                                                ...base,
                                                                padding: "2px 8px",
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                margin: "0",
                                                                padding: "0",
                                                            }),
                                                            indicatorsContainer: (base) => ({
                                                                ...base,
                                                                height: "44px",
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            {/* <Grid item xs={12} sm={6} className="formGridItem">
                                                <div className="formInput">
                                                    <label>Month *</label>
                                                    <Select
                                                        options={monthOptions}
                                                        onChange={handleMonthSelectChange}
                                                        required
                                                        className="selectInput"
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: "46px",
                                                                borderColor: "#e2e8f0",
                                                                "&:hover": {
                                                                    borderColor: "#cbd5e0",
                                                                },
                                                            }),
                                                            valueContainer: (base) => ({
                                                                ...base,
                                                                padding: "2px 8px",
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                margin: "0",
                                                                padding: "0",
                                                            }),
                                                            indicatorsContainer: (base) => ({
                                                                ...base,
                                                                height: "44px",
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                            </Grid> */}
                                            <Grid item xs={12} sm={6} className="formGridItem">
                                                <div className="formInput">
                                                    <label>Month *</label>
                                                    <TextField
                                                        type="month"
                                                        value={selectedMonth}
                                                        onChange={handleMonthChange}
                                                        required
                                                        fullWidth
                                                        InputProps={{
                                                            inputProps: { min: "2020-01", max: "2038-12" },
                                                        }}
                                                        sx={{
                                                            "& .MuiInputBase-input": {
                                                                padding: "8px",
                                                                borderRadius: "4px",
                                                                border: "1px solid #e2e8f0",
                                                                "&:hover": {
                                                                    borderColor: "#cbd5e0",
                                                                },
                                                                "&:focus": {
                                                                    borderColor: "#7451f8",
                                                                    outline: "none",
                                                                    boxShadow: "0 0 0 2px rgba(116, 81, 248, 0.2)",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            </Grid>

                                            <Grid item xs={12} sm={6} className="formGridItem">
                                                <div className="formInput">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={isUpcoming}
                                                                onChange={handleUpcomingChange}
                                                                sx={{
                                                                    color: "#7451f8",
                                                                    "&.Mui-checked": {
                                                                        color: "#7451f8",
                                                                    },
                                                                    "& .MuiSvgIcon-root": {
                                                                        fontSize: 24,
                                                                    },
                                                                    "&:hover": {
                                                                        backgroundColor: "rgba(116, 81, 248, 0.04)",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="Mark as Upcoming"
                                                        sx={{
                                                            "& .MuiFormControlLabel-label": {
                                                                color: "#6c757d",
                                                                fontSize: "0.875rem",
                                                                fontWeight: 500,
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            {!isUpcoming && (
                                                <>
                                                    <Grid item xs={12} sm={6} className="formGridItem">
                                                        <div className="formInput">
                                                            <label>Effective From *</label>
                                                            <input
                                                                type="date"
                                                                name="effective_from"
                                                                value={inputValues.effective_from}
                                                                onChange={handleInputChange}
                                                                required
                                                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                            />
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} className="formGridItem">
                                                        <div className="formInput">
                                                            <label>Effective To</label>
                                                            <input
                                                                type="date"
                                                                name="effective_to"
                                                                value={inputValues.effective_to}
                                                                onChange={handleInputChange}
                                                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                                                            />
                                                        </div>
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: 3,
                                                mt: 4,
                                                pb: 2,
                                            }}
                                        >
                                            <Button
                                                variant="outlined"
                                                color="secondary"
                                                onClick={() => navigate("/time-table")}
                                                sx={{ minWidth: "120px", height: "42px" }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading}
                                                sx={{ minWidth: "150px", height: "42px" }}
                                                startIcon={
                                                    isLoading ? (
                                                        <CircularProgress size={20} color="inherit" />
                                                    ) : null
                                                }
                                            >
                                                {isLoading ? "Processing..." : "Create Timetable"}
                                            </Button>
                                        </Box>
                                    </form>
                                </CardContent>
                            </Card>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer position="top-right" autoClose={3000} />
        </ThemeProvider>
    );
};

export default TimeTableMasterNew;